module.exports = __webpack_public_path__ + "static/hipsterSizesMB-31b3aee4f7906f0008b2465e7e0f58c0.webp";